'use strict';

export class PushNotificationsPanelService {
	static $inject = ['mx.shell.SidebarService', 'mx.shell.View', 'mx.internationalization'];

	constructor(sidebarService, MxView, i18n) {
		this.sidebarService = sidebarService;
		this.i18n = i18n;

		this._view = new MxView({
			id: 'push_notifications_panel',
			name: i18n.get('solutionBuilderAgent.push-notifications.pushNotifications'),
			template: '<mx-push-notifications-panel></mx-push-notifications-panel>',
		});
	}

	togglePanel() {
		if (this._isPanelOpened()) {
			this.closePanel();
		} else {
			this.openPanel();
		}
	}

	openPanel() {
		if (this._isPanelOpened()) {
			return;
		}
		this.sidebarService.open(this._view);
	}

	closePanel() {
		this.sidebarService.close();
	}

	_isPanelOpened() {
		return this.sidebarService.view && this.sidebarService.view.id === this._view.id;
	}
}
